import { createFileRoute, Outlet } from '@tanstack/react-router'
import type { ComponentProps } from 'react'
import { Boundary, Page } from '~/components'
import { useCurrentRouteId } from '~/hooks'
import { NavbarActionsProvider } from '~/providers/NavbarACtionsContext'

export const Route = createFileRoute('/workspaces/$workspaceId/profile')({
  component: Component,
})

function Component() {
  const currentRouteId = useCurrentRouteId() ?? ''

  const items: ComponentProps<typeof Page>['navbarItems'] = [
    {
      children: 'Profile',
      to: '/workspaces/$workspaceId/profile/account',
    },
    {
      children: 'Access Tokens',
      to: '/workspaces/$workspaceId/profile/settings',
    },
  ]

  const itemsWithActiveState = items.map((i) => ({
    ...i,
    active: currentRouteId.includes(i?.to ?? 'not-a-path'),
  }))

  return (
    <NavbarActionsProvider>
      <Page title="Account Settings" navbarItems={itemsWithActiveState}>
        <Boundary>
          {/* TODO: Add Skeleton loading screen */}
          <Outlet />
        </Boundary>
      </Page>
    </NavbarActionsProvider>
  )
}
